import React, { useEffect, useRef, useState } from 'react';
import EmojiPicker from 'emoji-picker-react';
import ReactQuill from 'react-quill';
import s from './ToolsButtons.module.css';
import IconEmojiHappy from '../../../../shared/ui/icons/emodji/IconEmojiHappy';

interface EmojiButtonProps {
    isActive?: boolean;
    onClick?: () => void;
    quillRef: React.RefObject<ReactQuill>;
}

const EmojiButton: React.FC<EmojiButtonProps> = ({ isActive, onClick, quillRef }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    const toggleEmoji = () => {
        setIsOpen((prev) => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (emojiData: any) => {
        const editor = quillRef.current?.getEditor();
        const emoji = emojiData.emoji;

        if (!editor) return;

        const range = editor.getSelection();
        if (range) {
            editor.insertText(range.index, emoji, 'user');
            editor.setSelection(range.index + emoji.length);
        } else {
            const length = editor.getLength();
            editor.insertText(length, emoji, 'user');
            editor.setSelection(length + emoji.length);
        }
    };

    return (
        <div className={s.emoji_menu_wrapper} ref={menuRef}>
            <button className={s.container} onClick={toggleEmoji}>
                <IconEmojiHappy />
            </button>
            {isOpen && (
                <div className={s.picker_wrapper}>
                    <EmojiPicker
                        onEmojiClick={handleSelect}
                        height={350}
                        width={300}
                        searchDisabled={true}
                        skinTonesDisabled={true}
                    />
                </div>
            )}
        </div>
    );
};

export default EmojiButton;
